import {Button, Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, useDisclosure} from '@chakra-ui/react'
import { useEffect, useState, useRef, startTransition } from 'react'
import { Html5Qrcode} from 'html5-qrcode'

export function Scanner ({ setQrMessage }) {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [ isScannerOpen, setScannerOpen ] = useState(false)
    const qrCodeRef = useRef(null)
    const containerRef = useRef(null)

    const qrCodeSuccess = (decodedText) => {
        if (typeof setQrMessage === 'function') { setQrMessage(decodedText) }
        startTransition(() => {
            setScannerOpen(false)
        })
        onClose()
    }

    const qrCodeScannerStop = () => {
        if (qrCodeRef.current && isScannerOpen) {
            qrCodeRef.current
                .stop()
                .then(() => qrCodeRef.current.clear())
                .catch(() => console.log('Scanner error'))
        }
    }

    const openScanner = () => {
        if (!containerRef.current) {
            return
        }

        const config = { fps: 10, qrbox: { width: 480, height: 300 } }
        qrCodeRef.current = new Html5Qrcode(containerRef.current.id)
        qrCodeRef.current.start({ facingMode: 'environment' }, config, qrCodeSuccess)
            .catch((err) => {
                console.error('Failed to start QR scanner:', err)
            })
        setQrMessage('')
    }

    useEffect(() => {
        if (isScannerOpen) {
            openScanner()
        } else {
            qrCodeScannerStop()
        }

        return () => {
            qrCodeScannerStop()
        }
    }, [isScannerOpen])


    return ( 
        <div className='scanner'>
            <Button variant='outline' onClick={() => {
                onOpen()
                startTransition(() => {
                    setScannerOpen(true)
                })
            }}>
                Scan
            </Button>
            <Modal isOpen={isOpen} onClose={() => { setScannerOpen(false); onClose() }} isCentered size='xl'>
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalBody p={5} textAlign='center'>
                            <div 
                                id='qr-reader'
                                ref={containerRef} 
                                style={{ width: 500 }}>
                            </div>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </div>
    )
}

 